import { defineMessages } from "react-intl"

export default defineMessages({
  customerPortal: {
    defaultMessage: "Customer Portal",
    id: "src.App.customerPortal",
  },
})
